<template>
  <div class="course-ppt-container">
    <iframe :src="src" style="width: 100%; height: 100%;"/>
  </div>
</template>

<script>
export default {
  name: 'CoursePPT',
  data() {
    return {
      src: ''
    }
  },
  created() {
    this.src = 'https://ow365.cn/?i=23714&n=5&ssl=1&furl=' + this.$route.query.url
  }
}
</script>

<style scoped>
.course-ppt-container{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>